import tw from 'twin.macro'
import { useContext } from 'react'
import { ContractorsContext } from '../contractors/Contractors.context'
import { ContractorStatusSelect } from '../shared/ContractorStatusSelect'
import { ContractorState } from 'src/constants/contractor/enums'
import { ContractorsTableContext } from '../contractors-table/ContractorsTable.context'
import { TableTagsSelect } from 'src/components/shared/table/TableTagsSelect'
import { TableSearch } from 'src/components/shared/table/TableSearch'

interface Props {
  selectedContractorState: ContractorState
}

export const ContractorsHeader = ({ selectedContractorState }: Props) => {
  const { setSearchQuery, searchQuery } = useContext(ContractorsContext)
  const { tagsFilter, setTagsFilter } = useContext(ContractorsTableContext)

  return (
    <div
      css={tw`flex flex-row items-center justify-between px-4 py-3 bg-white border-0 border-b border-t border-solid border-[#EDEDED]`}
    >
      <div css={tw`flex flex-row items-center gap-4`}>
        <TableSearch searchQuery={searchQuery} onChangeSearchQuery={setSearchQuery} />
        <ContractorStatusSelect selectedContractorState={selectedContractorState} />
        <TableTagsSelect selectedTags={tagsFilter} setSelectedTags={setTagsFilter} />
      </div>
    </div>
  )
}
